'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import UnitSelectController from "./controller/unitSelect";
import UnitsController from "./controller/units";
import UnitModalCreateController from "./controller/unitModalCreate";
import UnitTableDirective from "./directive/unitTable";
import UnitService from "./service/unit";

export default angular.module('investmentProject.unit', [])
    .controller('UnitSelectController', UnitSelectController)
    .controller('UnitsController', UnitsController)
    .controller('UnitModalCreateController', UnitModalCreateController)
    .directive('unitTable', UnitTableDirective)
    .factory('UnitService', UnitService)
    .name;
